import $ from 'jquery';
import formatPods from './formatPods';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    formatPods(`[data-section-id="${e.detail.sectionId}"]`);
  });
};